import { useDispatch, useSelector } from 'react-redux';
import { selectSelectedAddonsProduct, setSelectedAddons } from '../../../features/guest/guestSlice';
import { AddOnsData } from '../../../features/setup/setupResponse';
import { useMemo } from 'react';

interface ProductModalAddonsProps {
    addons: AddOnsData[] | undefined
}

type DisplayAddon = AddOnsData & {
    isRemoved?: boolean;
};

export default function ProductModalAddons({ addons }: ProductModalAddonsProps) {
    
    const dispatch = useDispatch()
    const selectedAddons = useSelector(selectSelectedAddonsProduct) ?? [];

    const handleToggleAddon = (addon: AddOnsData) => {
        dispatch(setSelectedAddons(addon));
    };

    const mergedAddons = useMemo<DisplayAddon[]>(() => {
        const current = addons ?? [];

        const removed = selectedAddons
            .filter(
                selected =>
                    !current.some(
                        addon => addon.addonID === selected.addonID
                    )
            )
            .map(addon => ({
                ...addon,
                isRemoved: true,
            }));

        return [...current, ...removed];
    }, [addons, selectedAddons]);
    
    return (
        <div className="space-y-2">
            <p className="text-xs font-semibold text-gray-700">
                Add-ons <span className="text-gray-400 font-normal">(Optional)</span>
            </p>
            <div className="grid grid-cols-2 gap-1">
                {mergedAddons.map(addon => {
                    const isRemoved = addon.isRemoved === true;
                    const isSelected = selectedAddons.some(item => item.addonID === addon.addonID);
                    const disabled = !isRemoved && (addon.isOutOfStock || !addon.isActive);
                    let buttonClass = "border-gray-300 hover:border-cbColor hover:bg-orange-50";
                    if (isRemoved) {
                        buttonClass =
                            "border-red-300 bg-red-50 text-red-600";
                    } else if (disabled) {
                        buttonClass =
                            "border-gray-300 bg-gray-200 text-gray-400 cursor-not-allowed";
                    } else if (isSelected) {
                        buttonClass =
                            "border-cbColor bg-orange-100";
                    }

                    return (
                        <button
                            key={addon.addonID}
                            type="button"
                            disabled={disabled}
                            onClick={() => handleToggleAddon(addon)}
                            className={`rounded border px-2 py-1 text-xs transition ${buttonClass}`}
                        >
                            <div className={isRemoved ? "line-through font-medium" : "" }>
                                {addon.addonName}
                            </div>
                            {isRemoved && (
                                <div className="mt-0.5 text-[10px] text-red-500">No longer available</div>
                            )}
                        </button>
                    );
                })}
            </div>
        </div>
    )
}
